import { Transaction } from '@aloft/toolkit-shared';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { selectTransactionEntities } from '../../../redux/features/selectors/propertyDataSelectors/transactionSelectors.ts';
import { CompTransactions } from './types.ts';

/** @deprecated Use {@link selectTransactionEntities} instead  */
export const createCompTransactionsFromTransactions = (
  comps: Record<string, Transaction>,
  compSequence: string[],
): CompTransactions =>
  Object.fromEntries(
    compSequence.map((propID) => {
      const comp = comps[propID];

      return [
        propID,
        {
          listingStatus: comp?.status,
          contractMonth: comp?.contractDate,
          closeMonth: comp?.saleDate,
          expirationDate: comp?.expirationDate,
          withdrawalDate: comp?.withdrawalDate,
        },
      ];
    }),
  );
